import VideoFilePlayer from './file-player'
import VideoLinkPlayer from './link-player'

export default VideoFilePlayer
export { VideoLinkPlayer }
